import { DocumentStatus } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const DocumentStatusOptions = Object.values(DocumentStatus).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
